import React from "react";
import { useState, useEffect } from "react";
import { toast } from "react-toastify";
import DialogBox from "../../components/DialogBox";
import FloatingButton from "../../components/FloatingButton";
import LinksTable from "../../components/LinksTable";
import LoadingSpinner from "../../components/LoadingSpinner";
import { instance as axios } from "../../utils/axiosConfig";

import { ref, uploadBytes, getDownloadURL } from "firebase/storage";
import { storage } from "../../utils/firebase.";
import { v4 } from "uuid";

export default function MyLinks() {
  const [isDialogOpen, setIsDialogOpen] = useState(false);
  const [fetching, setFetching] = useState(false);
  const [creating, setCreating] = useState(false);
  const [details, setDetails] = useState({
    slug: "",
    title: "",
    description: "",
    app_id: "",
    minimum_amount: 0,
    image: null,
  });

  const [links, setLinks] = useState([]);
  const [apps, setApps] = useState([]);

  //fetch user links
  const getLinks = async () => {
    setFetching(true);
    const resp = await axios.get("/user-links");
    // console.log(resp.data);
    setLinks(resp.data);
    setFetching(false);
  };

  const getApps = async () => {
    const resp = await axios.get("/get-user-apps");
    setApps(resp.data.apps);
  };

  const handleChange = (e) => {
    setDetails({ ...details, [e.target.name]: e.target.value });
  };

  const uploadImage = async () => {
    const imageRef = ref(storage, `images/${details.image.name + v4()}`);
    return uploadBytes(imageRef, details.image).then((snapshot) => {
      return getDownloadURL(snapshot.ref).then((url) => {
        return url;
      });
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    // console.log(details);
    setCreating(true);
    try {
      let imageurl = null;
      if (details.image) {
        imageurl = await uploadImage();
      }
      const resp = await axios.post("/create-link", {
        slug: details.slug,
        title: details.title,
        app_id: details.app_id,
        minimum_amount: details.minimum_amount,
        description: details.description,
        avator: imageurl,
      });

      // console.log(resp.data.message);
      toast.success(resp.data.message);
      setCreating(false);
      handleDialogClose();
      getLinks();
    } catch (error) {
      toast.error(error.response.data);
      setCreating(false);
    }
  };

  const handleDialogClose = () => {
    setDetails({
      slug: "",
      title: "",
      description: "",
      app_id: "",
      minimum_amount: 0,
      image: null,
    });
    setIsDialogOpen(false);
  };

  useEffect(() => {
    getLinks();
    getApps();
  }, []);

  return (
    <div>
      {fetching ? (
        <LoadingSpinner />
      ) : (
        <>
          <LinksTable links={links} />
          {!isDialogOpen && (
            <FloatingButton
              title="Create Payment link"
              func={() => setIsDialogOpen(true)}
            />
          )}
          <DialogBox
            isOpen={isDialogOpen}
            setIsOpen={setIsDialogOpen}
            title="Create Payment Link"
            onClose={handleDialogClose}
          >
            {creating ? (
              <LoadingSpinner />
            ) : (
              <form onSubmit={handleSubmit}>
                <div className="mb-6">
                  <label
                    htmlFor="name"
                    className="block mb-2 text-sm font-medium text-gray-900 "
                  >
                    Name Your Link
                  </label>
                  <div className="flex bg-yellow-100 border border-yellow-400  rounded-lg">
                    <h1 className="py-2.5 pl-2.5 text-gray-600 text-sm">
                      https://lipia-online.vercel.app/link/
                    </h1>
                    <input
                      type="text"
                      name="slug"
                      value={details.slug}
                      onChange={handleChange}
                      className="bg-yellow-100 text-yellow-900 text-sm rounded-lg focus:outline-none  block w-full py-2.5 px-1"
                      placeholder="your link"
                      required
                    />
                  </div>
                  {/* <p class="mt-2 text-sm text-green-600 ">available</p> */}
                </div>
                <div className="mb-6">
                  <label
                    htmlFor="apps"
                    className="block mb-2 text-sm font-medium text-gray-900"
                  >
                    Select App
                  </label>
                  <select
                    id="apps"
                    name="app_id"
                    onChange={handleChange}
                    value={details.app_id}
                    className="bg-yellow-100 border border-yellow-400 text-yellow-900 text-sm rounded-lg focus:ring-yellow-400 focus:ring-2 focus:outline-none block w-full p-2.5"
                  >
                    <option value="">Select App</option>
                    {apps.length >= 1 &&
                      apps.map((item) => (
                        <option key={item._id} value={item._id}>
                          {item.name} - {item.type}
                        </option>
                      ))}
                  </select>
                </div>
                <div className="mb-6">
                  <label
                    htmlFor="name"
                    className="block mb-2 text-sm font-medium text-gray-900 "
                  >
                    Link Title
                  </label>
                  <input
                    type="text"
                    name="title"
                    value={details.title}
                    onChange={handleChange}
                    className="bg-yellow-100 border border-yellow-400 text-yellow-900 text-sm rounded-lg focus:ring-yellow-400 focus:ring-2 focus:outline-none block w-full p-2.5"
                    placeholder="title"
                    required
                  />
                  <p class="mt-2 text-sm text-gray-600 ">
                    this will appear to your customers
                  </p>
                </div>
                <div className="mb-6">
                  <label
                    htmlFor="description"
                    className="block mb-2 text-sm font-medium text-gray-900 "
                  >
                    Description
                  </label>
                  <textarea
                    type="text"
                    name="description"
                    value={details.description}
                    onChange={handleChange}
                    className="bg-yellow-100 border border-yellow-400 text-yellow-900 text-sm rounded-lg focus:ring-yellow-400 focus:ring-2 focus:outline-none block w-full p-2.5"
                    placeholder="briefly describe the purpose of this link"
                    required
                  />
                </div>
                <div className="mb-6">
                  <label
                    htmlFor="name"
                    className="block mb-2 text-sm font-medium text-gray-900 "
                  >
                    minimum amount
                  </label>
                  <input
                    type="number"
                    name="minimum_amount"
                    value={details.minimum_amount}
                    onChange={handleChange}
                    className="bg-yellow-100 border border-yellow-400 text-yellow-900 text-sm rounded-lg focus:ring-yellow-400 focus:ring-2 focus:outline-none block w-full p-2.5"
                    placeholder="Eg 10 , 200 "
                    required
                  />
                  <p class="mt-2 text-sm text-gray-600 ">
                    The least amount to be paid to this link
                  </p>
                </div>
                <div className="mb-6">
                  <label
                    htmlFor="avator"
                    className="block mb-2 text-sm font-medium text-gray-900 "
                  >
                    Avator image (optional)
                  </label>
                  <div className="flex mb-4 items-center justify-center w-full">
                    {!details.image ? (
                      <label className="flex flex-col items-center justify-center w-full border-2 border-gray-300 border-dashed rounded-lg cursor-pointer bg-gray-50 hover:bg-gray-100  ">
                        <div className="flex flex-col items-center justify-center pt-5 pb-6">
                          <svg
                            aria-hidden="true"
                            className="w-10 h-10 mb-3 text-gray-400"
                            fill="none"
                            stroke="currentColor"
                            viewBox="0 0 24 24"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              stroke-linecap="round"
                              stroke-linejoin="round"
                              stroke-width="2"
                              d="M7 16a4 4 0 01-.88-7.903A5 5 0 1115.9 6L16 6a5 5 0 011 9.9M15 13l-3-3m0 0l-3 3m3-3v12"
                            ></path>
                          </svg>
                          <p className="mb-2 text-sm text-gray-500 ">
                            <span className="font-semibold">
                              Click to upload
                            </span>
                          </p>
                          <p className="text-xs text-gray-500 ">
                            This will appear as an avator (optional)
                          </p>
                        </div>
                        <input
                          type="file"
                          className="hidden"
                          name="image"
                          accept="image/*"
                          onChange={(e) => {
                            URL.revokeObjectURL(details.image);
                            setDetails({
                              ...details,
                              [e.target.name]: e.target.files[0],
                            });
                          }}
                        />
                      </label>
                    ) : (
                      <label className="flex flex-col items-center justify-center w-full border-2 border-gray-300 border-dashed rounded-lg cursor-pointer bg-gray-50 hover:bg-gray-100">
                        <div className="flex flex-col items-center justify-center pt-5 pb-6">
                          <img
                            src={
                              details.image
                                ? URL.createObjectURL(details.image)
                                : ""
                            }
                            alt="Avator"
                            className="w-20 h-20 rounded-full object-contain"
                          />
                          <p className="mb-2 text-sm text-gray-500 ">
                            <span className="font-semibold">
                              Click to change Image
                            </span>
                          </p>
                        </div>
                        <input
                          type="file"
                          className="hidden"
                          name="image"
                          accept="image/*"
                          onChange={(e) => {
                            URL.revokeObjectURL(details.image);
                            setDetails({
                              ...details,
                              [e.target.name]: e.target.files[0],
                            });
                          }}
                        />
                      </label>
                    )}
                  </div>
                </div>
                <button
                  type="submit"
                  className="text-yellow-900 bg-yellow-400 opacity-80 hover:bg-yellow-300 focus:ring-3 focus:outline-none focus:ring-yellow-800 font-medium rounded-lg text-sm w-full sm:w-auto px-5 py-2.5 text-center"
                >
                  Create Request
                </button>
              </form>
            )}
          </DialogBox>
        </>
      )}
    </div>
  );
}
